/**
 * In-memory vendor logos for the new-customer wizard.
 * Files cannot be persisted in sessionStorage, so this survives step navigation
 * only within the current browser tab session. Keyed by normalised vendor URL
 * so remounts (new draft ids) still find the File.
 */

import { normalizeWebsite } from "../utils/websiteUrl";

const vendorLogoFiles = new Map<string, File>();

export function vendorLogoKey(url: string): string {
  return normalizeWebsite(url).toLowerCase();
}

export function setVendorLogoFile(url: string, file: File | null): void {
  const key = vendorLogoKey(url);
  if (!key) {
    return;
  }
  if (file) {
    vendorLogoFiles.set(key, file);
    return;
  }
  vendorLogoFiles.delete(key);
}

export function getVendorLogoFile(url: string): File | null {
  const key = vendorLogoKey(url);
  if (!key) {
    return null;
  }
  return vendorLogoFiles.get(key) ?? null;
}

export function clearVendorLogoFile(url: string): void {
  const key = vendorLogoKey(url);
  if (!key) {
    return;
  }
  vendorLogoFiles.delete(key);
}

export function clearAllVendorLogoFiles(): void {
  vendorLogoFiles.clear();
}
